import { render, staticRenderFns } from "./TableUser.vue?vue&type=template&id=0062c1d8"
import script from "./TableUser.vue?vue&type=script&lang=js"
export * from "./TableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports